import { render, staticRenderFns } from "./FormBreadcrumb.vue?vue&type=template&id=5024d80e&scoped=true&lang=pug&"
import script from "./FormBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./FormBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024d80e",
  null
  
)

export default component.exports